import React from 'react'

const Zones = () => {
    return (
        <>Zones mobile</>
    )
}

export { Zones }